import React from "react"
import { createContext, useMemo, useEffect, useState } from "react"

const CommonContext = createContext({});


const CommonProvider = ({children}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [competitionModalOpen, setCompetitionModalOpen] = useState(false);


  const isCompetitionModalOpen = useMemo(() => competitionModalOpen, [competitionModalOpen]);
  const isMenuOpen = useMemo(() => menuOpen, [menuOpen]);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const closeMenu = () => {
    setMenuOpen(false);
  }
  const openMenu = () => {
    setMenuOpen(true);
  }

  const openCompetitionModal = () => {
    setCompetitionModalOpen(true);
  }

  const closeCompetitionModal = () => {
    setCompetitionModalOpen(false);
  }

  const toggleCompetitionModal = () => {
    setCompetitionModalOpen(!competitionModalOpen);
  }

  useEffect(()=>{
    if(menuOpen){
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  },[menuOpen]);

  return (
    <CommonContext.Provider value={{
      isMenuOpen,
      toggleMenu,
      closeMenu,
      openMenu,
      isCompetitionModalOpen,
      openCompetitionModal,
      closeCompetitionModal,
      toggleCompetitionModal
    }}
    >
      {children}
    </CommonContext.Provider>
  );
}

const CommonConsumer = CommonContext.Consumer;


const useCommonContext = () => {
  const context = React.useContext(CommonContext);
  if (context === undefined) {
    throw new Error('useCommonContext must be used within a CommonProvider');
  }
  return context;
}

export { CommonConsumer as Consumer, CommonProvider as Provider, useCommonContext };

export default CommonProvider;